function empty() {
  return [];
}

export default function(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-selection/src/selectorAll.js
// module id = vyt3
// module chunks = 0